<template>
  <div mt-5 class="scheduler">
    <v-flex class="scheduler__date-selector">
      <v-btn flat icon @click.native="prevDate" :disabled="isPrevDateDisabled">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-menu
        ref="menu"
        class="date-menu"
        :close-on-content-click="false"
        v-model="menu"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          v-model="computedDateFormatted"
          label="Picker in menu"
          readonly
        ></v-text-field>
        
        <v-date-picker v-model="date" show-current scrollable @input="updateDate" :min="min">
        </v-date-picker>
      </v-menu>

      <v-btn flat icon @click.native="nextDate">
        <v-icon>arrow_forward</v-icon>
      </v-btn>
    </v-flex>

    <v-layout column align-center>
      <v-flex
        v-if="appointments.length > 0"
        mt-4
        
        v-for="appt in appointments"
        :key="appt.time">
        <v-card
          hover
          ripple
          :width="300"
          @click.native="selectDate(appt)">
          <v-card-title primary-title>
            <div class="headline">
              <span>{{ appt.localTime }}</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex
        v-if="appointments.length === 0 && !isLoading">
        <v-card
          hover
          ripple
          :width="300">
          <v-card-title primary-title>
            <div class="headline">
              <span>There are no available appointments for the day.</span>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

     <v-dialog
      v-model="isLoading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by searching for available appointments
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
// import appointmentService from '@/framework/appointment/appointmentService'
// const { apis } = require('../../../../api-js/dist')
import { apis } from '@danckuts/api-js'

export default {
  props: {
    searchable: {
      type: Boolean,
      required: false
    }
  },
  data: () => {
    return {
      date: undefined,
      menu: false,
      min: undefined,
      /* THE FOLLOWING IS FOR SCHEDULER ONLY */
      appointments: [],
      schedule: undefined,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      location: 'user/getLocation'
    }),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    isPrevDateDisabled () {
      return this.date === this.min
    }
    /* THE FOLLOWING IS FOR SCHEDULER ONLY */
  },
  watch: {
    searchable (val) {
      if (val && this.appointments.length === 0) {
        this.searchAppointments()
      }
    }
  },
  created () {
    this.min = moment().format('YYYY-MM-DD')
    this.date = moment().format('YYYY-MM-DD')
    /* THE FOLLOWING IS FOR SCHEDULER ONLY */
    if (this.searchable) {
      this.searchAppointments()
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    nextDate () {
      this.date = moment(this.date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      this.searchAppointments()
    },
    prevDate () {
      if (this.date !== this.min) {
        this.date = moment(this.date, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')
        this.searchAppointments()
      }
    },
    updateDate (date) {
      this.searchAppointments()
      this.menu = false
    },
    /* THE FOLLOWING IS FOR SCHEDULER ONLY */
    searchAppointments () {
      this.isLoading = true
      this.appointments = []
      apis.ScheduleService.get(this.location.id.toLowerCase(), this.date).then(res => {
        this.schedule = res
        if (res.slotAppointmentInfo && res.slotAppointmentInfo.length > 0) {
          this.appointments = res.slotAppointmentInfo.filter(a => a.available > 0)
        }
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    selectDate (appointmentSlot) {
      this.$emit('selectDate', appointmentSlot, this.date)
    }
  }
}
</script>

<style lang="scss">
.scheduler {
  text-align: center;

  &__date-selector {
    display: block;
  }
}
.date-menu {
  display: inline-block !important;
}
</style>
